import React from "react";
import "./Schooldetails.css";
import TeacherEvaluation from "../../assest/Teacher_Evaluation.png";
import Parentquestion from "../../assest/parent-questionaire.png";
import Childquestion from "../../assest/child_assessment.png";
import { useNavigate, useParams } from "react-router-dom";
import { Domain, Workspace } from "../../path";
import { useEffect } from "react";
import { useState } from "react";
import usePost from "../../Hooks/usePost";
import { useDispatch } from "react-redux";
import { Set_Loader } from "../../Redux/Action/LoaderAction";

const Schooldetails = () => {
  const Navigation = useNavigate();
  const Dispatch = useDispatch();
  const { id } = useParams();
  const [ClassList, setClassList] = useState([]);
  const ClasslistData = usePost(`${Workspace[Domain].API_Path}/class_list`);

  const Class_Handler = (classid) => {
    Navigation(`/classdetail/${id}/${btoa(classid)}`);
  };
  const Go_Back = () => {
    Navigation(`/`);
  };
  const Get_SchoolDetails = () => {
    ClasslistData.Postcall({
      school_id: atob(id),
    });
  };

  const OtherClass_Handler = () => {
    Navigation(`/classdetail/${id}/${btoa("other")}`);
  };

  useEffect(() => {
    Get_SchoolDetails();
    return () => {
      setClassList();
    };
  }, [id]);

  useEffect(() => {
    if (ClasslistData.Post != null) {
      switch (ClasslistData.Post?.status) {
        case 200:
          setClassList(ClasslistData.Post?.body);
          Dispatch(Set_Loader(false));
          break;
        default:
          break;
      }
    }
  }, [ClasslistData.Post]);

  return (
    <div className="h-full p-2">
      <h3 className="school-title py-1 px-2 text-[white] text-3xl font-bold w-3/12 border-b-2 border-slate-200  max-[440px]:w-11/12 max-[440px]:py-2 max-[440px]:text-2xl">
        <button className="text-3xl mr-3 text-[black]" onClick={Go_Back}>
          <i class="fa-solid fa-arrow-left-long"></i>
        </button>
        <span className="text-[black]">School</span>{" "}
        <span className="text-[#f79221]">details</span>
      </h3>

      <h3 className="my-3">
        <b className="text-md text-[black]">School name :</b>
        <span className="ml-2">{ClassList?.school_name}</span>
      </h3>

      {/* COMPLETE PROGRESS  START*/}

      <div className="flex items-start flex-wrap justify-center">
        <div className="w-2/12  max-[500px]:w-3/12 flex flex-col items-center ">
          <div className="w-3/12 mb-2 max-[500px]:w-5/12">
            <img src={TeacherEvaluation} alt="" className="w-full" />
          </div>
          <div className="w-full h-4 rounded-xl bg-[#ccc] flex items-center justify-center max-[500px]:h-4 relative overflow-hidden">
            <span className="text-xs font-semibold relative z-10">
              {ClassList?.teacher_evaluation_completed}/
              {ClassList?.teacher_evaluation_total}
            </span>

            <div
              className={`absolute top-0 left-0 bg-[#2da3dc] h-full`}
              style={{
                width:
                  (ClassList?.teacher_evaluation_completed /
                    ClassList?.teacher_evaluation_total) *
                    100 +
                  "%",
              }}
            ></div>
          </div>
          <p className="text-center font-semibold my-2 max-[500px]:text-xs">
            Teacher Evaluation
          </p>
        </div>
        <div className="w-2/12 mx-5 max-[500px]:w-3/12 flex flex-col items-center ">
          <div className="w-3/12 mb-2 max-[500px]:w-5/12">
            <img src={Parentquestion} alt="" className="w-full" />
          </div>
          <div className="w-full h-4 rounded-xl bg-[#ccc] flex items-center justify-center max-[500px]:h-4 relative overflow-hidden">
            <span className="text-xs font-semibold relative z-10">
              {ClassList?.parent_evaluation_completed}/
              {ClassList?.parent_evaluation_total}
            </span>
            <div
              className={`absolute top-0 left-0 bg-[#2da3dc] h-full`}
              style={{
                width:
                  (ClassList?.parent_evaluation_completed /
                    ClassList?.parent_evaluation_total) *
                    100 +
                  "%",
              }}
            ></div>
          </div>
          <p className="text-center font-semibold my-2 max-[500px]:text-xs">
            Parent's questionarie
          </p>
        </div>
        <div className="w-2/12  max-[500px]:w-3/12 flex flex-col items-center ">
          <div className="w-3/12 mb-2 max-[500px]:w-5/12">
            <img src={Childquestion} alt="" className="w-full" />
          </div>
          <div className="w-full h-4 rounded-xl bg-[#ccc] flex items-center justify-center max-[500px]:h-4 relative overflow-hidden">
            <span className="text-xs font-semibold relative z-10">
              {ClassList?.child_evaluation_completed}/
              {ClassList?.child_evaluation_total}
            </span>
            <div
              className={`absolute top-0 left-0 bg-[#2da3dc] h-full`}
              style={{
                width:
                  (ClassList?.child_evaluation_completed /
                    ClassList?.child_evaluation_total) *
                    100 +
                  "%",
              }}
            ></div>
          </div>
          <p className="text-center font-semibold my-2 max-[500px]:text-xs">
            Child assessment
          </p>
        </div>
      </div>
      {/* COMPLETE PROGRESS  END*/}

      {/* CLASS LIST START */}
      {ClassList?.class_list?.length > 0 && (
        <div className="bg-[white] w-6/12 mx-auto shadow-xl border mt-5 shadow-black-500/50 p-3 max-[600px]:w-11/12 ">
          <div>
            <div>
              <h4 className="font-bold text-[#2da3dc] text-1xl uppercase border-b-2 pb-1">
                Classes
              </h4>
            </div>

            <div>
              {ClassList?.class_list?.map((item, index) => {
                return (
                  <button
                    key={index}
                    className="bg-[#2da3dc] text-[white] py-1 px-3 rounded-md m-1 font-semibold text-sm"
                    onClick={() => {
                      Class_Handler(item?.class_id);
                    }}
                  >
                    {item?.class_standard}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="my-4">
            <div className="border-b-2 flex items-start justify-between max-[500px]:flex-col">
              <h4 className="font-bold text-[#2da3dc] text-1xl uppercase  pb-1">
                Others
              </h4>

              <p className="text-xs font-semibold text-[tomato] text-left">
                * Add children in others who are not in your current class here
              </p>
            </div>

            <div>
              <button
                onClick={OtherClass_Handler}
                className="bg-[#2da3dc] text-[white] py-1 px-3 rounded-md m-1 font-semibold text-sm"
              >
                Others
              </button>
            </div>
          </div>
        </div>
      )}
      {/* CLASS LIST END */}

      {/* IF NO CLASSES START */}
      {/* {!ClassList?.class_list?.length > 0 && (
        <div className="bg-[white] w-6/12 mx-auto shadow-xl border mt-5 shadow-black-500/50 p-3 max-[600px]:w-11/12 hidden">
          <h3 className="font-semibold text-center mb-4">
            Take the 3R assessment for the children in your classes who you
            think have difficulty performing to their potential and on par with
            other children their age
          </h3>

          <button className="block mx-auto my-5 bg-[#2da3dc] px-5 py-1 text-[white] font-semibold rounded-md">
            Create list
          </button>
        </div>
      )} */}
      {/* IF NO CLASSES END */}
    </div>
  );
};

export default Schooldetails;
